import React, { useState } from "react";
import { Actif, Site } from "../../interfaces";
import CustomDialog from "../CustomDialog";
import { getEntityInformation } from "./EntityInformations";

interface IArobrescenceBâtimentaireEditProps {
  site: Site;
  batimentIds?: any;
  niveauIds?: any;
  espaceIds?: any;
  pieceIds?: any;
  setSelectedBâtiments?: any;
  setSelectedNiveaux?: any;
  setSelectedEspaces?: any;
  setSelectedPieces?: any;
  selectedBâtiments?: any;
  selectedNiveaux?: any;
  selectedEspaces?: any;
  selectedPieces?: any;
  selectedUnités?: any;
  checkbox: boolean;
}
// Arborescence Bâtimentaire d'Edit Actif
export const ArborescenceBâtimentaireEditActif: React.FC<
  IArobrescenceBâtimentaireEditProps
> = ({
  site,
  checkbox,
  batimentIds,
  niveauIds,
  espaceIds,
  pieceIds,
  setSelectedBâtiments,
  setSelectedNiveaux,
  setSelectedEspaces,
  setSelectedPieces,
  selectedBâtiments,
  selectedNiveaux,
  selectedEspaces,
  selectedPieces,
  selectedUnités,
}) => {
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [selectedEntityType, setSelectedEntityType] = useState("");

  const [modals, setModals] = useState({
    bâtiment: false,
    niveau: false,
    espace: false,
    pièce: false,
  });

  const openModal = (modalName, entity) => {
    setModals({ ...modals, [modalName]: true });
    setSelectedEntityType(modalName);
    setSelectedEntity(entity);
  };
  const closeModal = (modalName) => {
    setModals({ ...modals, [modalName]: false });
    setSelectedEntityType("");
    setSelectedEntity(null);
  };

  const handleSelection = (e, id, setSelectedItems) => {
    setSelectedItems((prevSelectedRows) => {
      if (prevSelectedRows.includes(id)) {
        return prevSelectedRows.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedRows, id];
      }
    });
  };

  return (
    <>
      {site?.batiments?.map((batiment) => (
        <>
          <div className="flex space-x-2" key={batiment?.id}>
            <img src="/images/prochain.png" className="w-8 h-8" />
            {checkbox && (
              <div className="flex items-center">
                <input
                  id="checkbox-table-search-1"
                  type="checkbox"
                  checked={selectedBâtiments?.includes(batiment.id)}
                  onChange={(e) =>
                    handleSelection(e, batiment.id, setSelectedBâtiments)
                  }
                  className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
              </div>
            )}
            <button
              type="button"
              onClick={() => openModal("bâtiment", batiment)}
              className={`  flex px-3 py-1  font-semibold text-md text-black border   rounded-md ${
                batimentIds.includes(batiment.id)
                  ? "hover:bg-gray-200"
                  : "   bg-gray-300"
              }  ${
                selectedUnités?.some((unité) =>
                  unité?.bâtiments?.some((data) => data.id === batiment.id)
                )
                  ? "border-gexpertise-200 border-4"
                  : "border-gray-400"
              }  `}
            >
              <div className="flex space-x-3">
                <img src="/images/batiments-3d.png" className="w-6 h-6" />
                <span>{batiment?.nom_bâtiment} </span>
              </div>
            </button>
          </div>
          {batiment.niveaux
            ?.sort((a, b) => a.numero - b.numero)
            .map((niveau) => (
              <>
                <div className="flex space-x-2 ml-10" key={niveau?.id}>
                  <img src="/images/prochain.png" className="w-8 h-8" />
                  {checkbox && (
                    <div className="flex items-center">
                      <input
                        id="checkbox-table-search-1"
                        type="checkbox"
                        checked={selectedNiveaux?.includes(niveau.id)}
                        onChange={(e) =>
                          handleSelection(e, niveau.id, setSelectedNiveaux)
                        }
                        className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      />
                    </div>
                  )}
                  <button
                    type="button"
                    onClick={() => openModal("niveau", niveau)}
                    className={`flex px-3 py-1  font-semibold text-md text-black border   rounded-md ${
                      niveauIds.includes(niveau.id)
                        ? "hover:bg-gray-200"
                        : "  bg-gray-300"
                    }  ${
                      selectedUnités?.some((unité) =>
                        unité?.niveaux?.some((data) => data.id === niveau.id)
                      )
                        ? "border-gexpertise-200 border-4"
                        : "border-gray-400"
                    } `}
                  >
                    <div className="flex space-x-3">
                      <img src="/images/couches.png" className="w-6 h-6" />
                      <span>{niveau?.nom_niveau}</span>
                    </div>
                  </button>
                </div>
                {niveau.espaces?.map((espace) => (
                  <>
                    <div className="flex space-x-2 ml-20" key={espace?.id}>
                      <img src="/images/prochain.png" className="w-8 h-8" />
                      {checkbox && (
                        <div className="flex items-center">
                          <input
                            id="checkbox-table-search-1"
                            type="checkbox"
                            checked={selectedEspaces?.includes(espace.id)}
                            onChange={(e) =>
                              handleSelection(e, espace.id, setSelectedEspaces)
                            }
                            className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                        </div>
                      )}

                      <button
                        type="button"
                        onClick={() => openModal("espace", espace)}
                        className={` flex px-3 py-1  font-semibold text-md text-black border   rounded-md ${
                          espaceIds.includes(espace.id)
                            ? "hover:bg-gray-200"
                            : " bg-gray-300"
                        }   ${
                          selectedUnités?.some((unité) =>
                            unité?.espaces?.some(
                              (data) => data.id === espace.id
                            )
                          )
                            ? "border-gexpertise-200 border-4"
                            : "border-gray-400"
                        } `}
                      >
                        <div className="flex space-x-3">
                          <img src="/images/espace.png" className="w-6 h-6" />
                          <span>{espace?.nom_espace}</span>
                        </div>
                      </button>
                    </div>
                    {espace.pieces
                      ?.sort((a, b) => a.nom_piece.localeCompare(b.nom_piece))
                      .map((piece) => (
                        <div className="flex space-x-2 ml-32" key={piece?.id}>
                          <img src="/images/prochain.png" className="w-8 h-8" />
                          {checkbox && (
                            <div className="flex items-center">
                              <input
                                id="checkbox-table-search-1"
                                type="checkbox"
                                checked={selectedPieces?.includes(piece.id)}
                                onChange={(e) =>
                                  handleSelection(
                                    e,
                                    piece.id,
                                    setSelectedPieces
                                  )
                                }
                                className="w-5 h-5 text-gexpertise-200 bg-gray-100 border-gray-300 rounded focus:ring-gexpertise-200 dark:focus:ring-gexpertise-200 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                              />
                            </div>
                          )}

                          <button
                            type="button"
                            onClick={() => openModal("pièce", piece)}
                            className={`flex px-3 py-1  font-semibold text-md text-black border rounded-md ${
                              pieceIds.includes(piece.id)
                                ? "hover:bg-gray-200"
                                : " bg-gray-300"
                            }  ${
                              selectedUnités?.some((unité) =>
                                unité?.pieces?.some(
                                  (data) => data.id === piece.id
                                )
                              )
                                ? "border-gexpertise-200 border-4"
                                : "border-gray-400"
                            }`}
                          >
                            <div className="flex space-x-3">
                              <img
                                src="/images/piece.png"
                                className="w-6 h-6"
                              />
                              <span>{piece?.nom_piece}</span>
                            </div>
                          </button>
                        </div>
                      ))}
                  </>
                ))}
              </>
            ))}
        </>
      ))}
      {selectedEntityType && (
        <CustomDialog
          visible={modals[selectedEntityType]}
          closeModalDialog={() => closeModal(selectedEntityType)}
        >
          <div className="relative w-full h-full  ">
            {getEntityInformation(selectedEntity, selectedEntityType)}
          </div>
        </CustomDialog>
      )}
    </>
  );
};
